<template>
  <section>
    <header>
      <h1 class="page-header">Pricing</h1>
    </header>
    <section v-if="!loggedIn" class="alert alert-info">
      Note: You need to <router-link to="/register">register</router-link> before you can pay. When you do register, you'll automatically be entered in to the 14 day free trial.
    </section>
    <section class="alert alert-info">
      Interested in short deck? Head over to the <router-link to="/short-deck-pricing">short deck pricing page</router-link>.
    </section>
    <pricing-table />
  </section>
</template>

<script>
import PricingTable from '@/components/utilities/pricing-table';

export default {
  name: 'ppt-pricing',
  components: {
    'pricing-table': PricingTable,
  },
  computed: {
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pricing.vue